import { render, staticRenderFns } from "./ConsolidationMeestCreationSection.vue?vue&type=template&id=6bfe1161"
import script from "./ConsolidationMeestCreationSection.vue?vue&type=script&lang=js"
export * from "./ConsolidationMeestCreationSection.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationMeestCreationSection.vue?vue&type=style&index=0&id=6bfe1161&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports